module.exports = __webpack_public_path__ + "img/icon_qiuzhi02.fd8347ff.png";